export const importConfigs = {

  agents: {
    importUrl: "/api/import-agents/",
    downloadUrl: "/api/download-agent-csv/",
    compulsoryFields: ["Name", "Email"],
    optionalFields: ["Address"],
  },

  amcs: {
    importUrl: "/api/import-amcs/",
    downloadUrl: "/api/download-amc-csv/",
    compulsoryFields: ["Customer Name", "AMC Name"],
    optionalFields: [],
  },

  customers: {
    importUrl: "/api/import-customers/",
    downloadUrl: "/api/download-customer-csv/",
    compulsoryFields: ["Name", "Email"],
    optionalFields: ["Landmark"],
  },

  sales: {
    importUrl: "/api/import-sales/",
    downloadUrl: "/api/download-sales-csv/",
    compulsoryFields: ["Name", "Email", "Contact Number"],
    optionalFields: [],
  },

  stock: {
    importUrl: "/api/import-stock/",
    downloadUrl: "/api/download-stock-sample/",
    compulsoryFields: ["Item Name", "Description", "Quantity"],
    optionalFields: [],
  },

  leads: {
    importUrl: "/api/import-leads/",
    downloadUrl: "/api/download-lead-xlsx/",
    compulsoryFields: ["Customer Name", "Address"],
    optionalFields: ["Landmark"],
  },

  subcustomers: {
    importUrl: "/api/import-subcustomers/",
    downloadUrl: "/api/download-subcustomers-csv/",
    compulsoryFields: ["Name", "Email"],
    optionalFields: ["Landmark"],
  },

  superusers: {
    importUrl: "/api/import-superusers/",
    downloadUrl: "/api/download-superuser-csv/",
    compulsoryFields: ["Name", "Email"],
    optionalFields: ["Address"],
  },

  technicians: {
    importUrl: "/api/import-technicians/",
    downloadUrl: "/api/download-technician-csv/",
    compulsoryFields: ["Name", "Email", "Contact Number"],
    optionalFields: [],
  },

  tickets: {
    importUrl: "/api/import-tickets/",
    downloadUrl: "/api/download-tickets-csv/",
    compulsoryFields: ["Customer Name", "Address", "Phone Number"],
    optionalFields: ["Landmark"],
  },

};